import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import "@/form-fixes.css";
import "@/journal.css";
import "@/course.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import BlogArchive from "@/pages/BlogArchive";
import BlogArticle from "@/pages/BlogArticle";
import CoursePage from "@/pages/CoursePage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blogs" element={<BlogArchive />} />
        <Route path="/blogs/:slug" element={<BlogArticle />} />
        <Route path="/courses/:key" element={<CoursePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}
